import React, { Component } from 'react';
import { Input, Dropdown, Button } from 'semantic-ui-react';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { updateAdLibraryUrl } from '../../../utils/urls';
import { insertTag } from './../../../services/TagService';
import './AdPrototypeSearch.css';

class AdPrototypeSearch extends Component {
  state = {
    adTypes: [],
    selectedTags: {},
    form: {
      name: '',
      selectedTypes: []
    },
    tagOptions: {}
  };

  componentDidMount() {
    this.props.setRefreshProtypesHandler(this.filterPrototypes);
    this.initializeState();
  }

  clearFilters = () => {
    this.setState(
      (prevState) => ({
        ...prevState,
        selectedTags: {},
        form: {
          name: '',
          selectedTypes: []
        }
      }),
      () => {
        this.updateUrl();
        this.props.fetchAdPrototypes({
          activePage: 1,
          rowsPerPage: 4
        });
      }
    );
  };

  handleFormChange = ({ target }, { name }) => {
    const { value } = target;
    if (name === 'name') {
      this.setState(
        (prevState) => ({
          ...prevState,
          form: { ...prevState.form, name: value }
        }),
        () => {
          setTimeout(() => {
            this.filterPrototypes();
          }, 500);
        }
      );
      return;
    }
    clearTimeout(this.inputTimer);
    this.inputTimer = setTimeout(() => {
      this.setState(
        (prevState) => ({
          ...prevState,
          form: { ...prevState.form, [name]: value }
        }),
        () => {
          this.filterPrototypes();
        }
      );
    }, 250);
  };

  initializeState = () => {
    const { tags } = this.props;
    const adTypes = this.returnAdTypes();
    const { form, selectedTags } = this.returnInitialForm();
    const newTagOptionsDict = {};
    for (const category of Object.keys(tags)) {
      newTagOptionsDict[category] = this.getOptions(tags[category]);
    }
    this.setState((prevState) => ({
      ...prevState,
      adTypes,
      form,
      selectedTags,
      tagOptions: newTagOptionsDict
    }));
  };

  returnAdTypes = () => {
    const types = [
      'Canvas',
      'Carousel',
      'Collection',
      'Video',
      'Cinemagraph',
      'Still',
      'DAA'
    ];
    const adTypes = types.map((type, index) => ({
      key: index,
      text: type,
      value: type
    }));

    return adTypes;
  };

  returnInitialForm = () => {
    const { initialOutputQueryObject } = this.props;
    const newForm = {
      name: '',
      selectedTypes: []
    };
    const selectedTags = {};
    if (initialOutputQueryObject) {
      const paramKeys = Object.keys(initialOutputQueryObject);
      paramKeys.forEach((key) => {
        if (initialOutputQueryObject[key]) {
          if (key === 'type') {
            newForm.selectedTypes = initialOutputQueryObject[`${key}`];
          } else if (key === 'name') {
            newForm.name = initialOutputQueryObject[key];
          } else {
            // to do: handle page number propertyu
            const tagIds = Array.isArray(initialOutputQueryObject[key])
              ? initialOutputQueryObject[key]
              : [];
            selectedTags[key] = tagIds.map((tagId) => parseInt(tagId, 10));
          }
        }
      });
    }
    return { form: newForm, selectedTags };
  };

  onSearchTagsSelect = (e, data) => {
    const { id: category, value: selectedSearchKeys, options } = data;
    const tags = options.filter(
      (option) => selectedSearchKeys.indexOf(option.key) !== -1
    );

    const tagOptionKeys = tags.map((tag) => tag.key);

    this.setState(
      (prevState) => ({
        ...prevState,
        selectedTags: {
          ...prevState.selectedTags,
          [category]: tagOptionKeys
        }
      }),
      () => {
        this.filterPrototypes();
      }
    );
  };

  onSearchTypesSelect = async (e, data) => {
    const adTypes = [];

    data.value.forEach((val) => {
      const adType = _.find(data.options, (option) => {
        return option.value === val;
      });

      if (adType) {
        adTypes.push(adType.value);
      }
    });

    const form = this.state.form;
    form.selectedTypes = adTypes;

    this.setState({ form }, () => {
      this.filterPrototypes();
    });
  };

  getOptions = (tags) => {
    if (!tags) {
      return [];
    }

    const options = tags.map((tag) => ({
      key: tag.id,
      value: tag.id,
      text: tag.value,
      category: tag.category
    }));

    return options;
  };

  filterPrototypes = () => {
    const { selectedTags, form } = this.state;
    const { setOutputQueryObjInParent, fetchAdPrototypes } = this.props;
    if (!setOutputQueryObjInParent || !fetchAdPrototypes) {
      return;
    }
    const outputQueryObject = this.outputQueryObject(selectedTags, form);
    setOutputQueryObjInParent(outputQueryObject);
    fetchAdPrototypes(outputQueryObject);
  };

  outputQueryObject = (selectedTags, form) => {
    const queryObject = selectedTags;

    if (queryObject.name) {
      queryObject.name = form.name;
    }
    if (form.name !== '') {
      queryObject.name = form.name;
    }
    if (form.selectedTypes) {
      queryObject.type = form.selectedTypes;
    }

    this.updateUrl(queryObject);
    return queryObject;
  };

  updateUrl = (queryObject) => {
    const { tags: tagsFromProps, activePage } = this.props;
    const urlParamsObject = {
      name: '',
      oem: '',
      type: '',
      year: '',
      product: '',
      campaign: '',
      month: '',
      package: '',
      page: activePage || 1
    };

    // to do: refactor this
    if (queryObject) {
      const tagKeys = Object.keys(queryObject);
      try {
        tagKeys.forEach((key) => {
          const currentValue =
            queryObject[key] && queryObject[key].length > 0
              ? queryObject[key]
              : '';
          let tagValuesAsUrlParamValue = '';
          if (currentValue.constructor === Array) {
            if (key === 'type') {
              const lowerCaseValues = currentValue.map((value) =>
                value.toLowerCase()
              );
              tagValuesAsUrlParamValue = lowerCaseValues.join(',');
            } else {
              const tagsFromIdValues = currentValue.map((tagId) => {
                const tagObjectsFromProps = tagsFromProps[key];
                const foundTag = tagObjectsFromProps.find(
                  (tag) => tag.id === tagId
                );
                const { value } = foundTag || {};
                return value || '';
              });
              const tagsArray = tagsFromIdValues.filter(Boolean);
              tagValuesAsUrlParamValue = tagsArray.join(',');
            }
          } else {
            tagValuesAsUrlParamValue = currentValue;
          }
          urlParamsObject[`${key}`] = tagValuesAsUrlParamValue;
        });
      } catch (error) {
        console.log('Error occurred in updateUrl():', error);
      }
    }

    updateAdLibraryUrl(urlParamsObject);
  };

  toastOptions = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  };

  render() {
    const { selectedTypes, name } = this.state.form;
    const { selectedTags, adTypes, tagOptions } = this.state;
    const { tags, user, fillTags } = this.props;

    const tagOptionObjects = [
      { placeholder: 'OEM', category: 'oem' },
      {
        placeholder: 'Type',
        category: 'type',
        options: adTypes,
        value: selectedTypes,
        handleChange: this.onSearchTypesSelect
      },
      { placeholder: 'Year', category: 'year' },
      { placeholder: 'Model/Product', category: 'product' },
      { placeholder: 'Campaign', category: 'campaign' },
      { placeholder: 'Campaign Month', category: 'month' },
      { placeholder: 'Package', category: 'package' }
    ];

    const returnTagSearchDropdown = ({
      placeholder,
      category,
      options,
      value,
      handleChange
    }) => (
      <Dropdown
        key={`${category}-dropdown`}
        placeholder={placeholder}
        search
        multiple
        clearable
        selection
        id={category}
        value={value || selectedTags[category] || []}
        className="search-multiple-tags"
        options={
          options || tagOptions[category] || this.getOptions(tags[category])
        }
        onChange={handleChange || this.onSearchTagsSelect}
        onClick={this.onDropdownClick}
        allowAdditions
        onAddItem={async (event, { value: searchValue }) => {
          const { groups, email } = user || {
            email: 'alexia@constellationagency.com',
            groups: ['internal']
          };
          const applyGuestFilter = ['NU'].includes(groups[0]);

          const newTag = {
            category,
            value: searchValue,
            created_by: email,
            for_guest: applyGuestFilter
          };

          const insertTagResult = await insertTag(newTag);

          const { statusCode, tag: addedTag } = insertTagResult;

          if (statusCode !== 200 || !addedTag) {
            toast.error('The new tag could not be added.', this.toastOptions);
            return;
          }

          const { id } = addedTag;

          const newTagOption = {
            key: id,
            value: id,
            text: searchValue,
            category
          };

          const newTagOptions = this.getOptions(tags[category]).concat([
            newTagOption
          ]);

          if (!fillTags) {
            return;
          }

          const fillTagsStatus = await fillTags();

          if (fillTagsStatus === 'failure') {
            toast.warn(
              'An error occurred while refreshing the tags. Try refreshing the page.',
              this.toastOptions
            );
            return;
          }

          this.setState({
            ...this.state,
            tagOptions: {
              ...tagOptions,
              [category]: newTagOptions
            },
            selectedTags: {
              ...this.state.selectedTags,
              [category]: [
                ...this.state.selectedTags[category],
                newTagOption.value
              ]
            }
          });
        }}
      />
    );

    return (
      <div className="search-fields">
        <Input
          className="search-name"
          placeholder={name.trim() !== '' ? name : 'Name'}
          type="text"
          name="name"
          value={name}
          onChange={this.handleFormChange}
        />
        {tagOptionObjects.map((tagOptionObj) =>
          returnTagSearchDropdown({ ...tagOptionObj })
        )}
        <br />
        <div className="ui search-multiple-tags dropdown">
          <Button basic color="violet" onClick={this.clearFilters}>
            Clear Filters
          </Button>
        </div>
      </div>
    );
  }
}

export default AdPrototypeSearch;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdPrototypeSearch.js